module.exports = __webpack_public_path__ + "img/20191127162452360截图20191127160756055.e04d2f9f.jpg";